import React, { VFC } from 'react';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { Box, Button, makeStyles, FormHelperText } from '@dxb-web-ui-framework/design-system';
import { TFunction } from 'react-i18next';

export interface AddBankDetailsBtnProps {
  formBuilderProps: any;
  t: TFunction;
  otherMandatoryDataForUI: GenericObject;
  areFieldsHidden: boolean;
}

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
  },
}));

const AddBankDetailsBtn: VFC<AddBankDetailsBtnProps> = ({ formBuilderProps, t, areFieldsHidden }) => {
  const classes = useStyles();
  const title = areFieldsHidden
    ? t('fundsTransferPage.Forms.ReceivingBankDetails')
    : t('fundsTransferPage.Forms.ChangeReceivingBankDetails');

  const shouldShowHelperText =
    areFieldsHidden &&
    !formBuilderProps.isValid &&
    formBuilderProps.isSubmitted &&
    title === t('fundsTransferPage.Forms.ReceivingBankDetails');

  return (
    <>
      <Box className={classes.root}>
        <Button
          color='primary'
          size='large'
          variant='contained'
          disabled={formBuilderProps.externalProps.isLoading}
          title={title}
          onClick={formBuilderProps.externalEffectCallbacks.onToggleDrawer}>
          {title}
        </Button>
      </Box>
      {shouldShowHelperText && (
        <FormHelperText error={!formBuilderProps.isValid}>
          {t('fundsTransferPage.Forms.AddBankDetails.Button.HelperText')}
        </FormHelperText>
      )}
    </>
  );
};

export { AddBankDetailsBtn };
